export default __webpack_public_path__ + "static/media/fpa60004.d0929ea2.png";